export const getProjectDraftUrl = (projectId: number) => `projects/${projectId}/drafts`;

export const getProjectDraftFileUrl = (awsPath: (string, number) => string, projectId: number) => {
  return awsPath(`/${getProjectDraftUrl(projectId)}/project_${projectId}_draft.json`, Date.now());
};

export const getProjectDraftAssetUrl = (
  awsPath: (string, number) => string,
  projectId: number,
  asset: string,
) => {
  return awsPath(`/${getProjectDraftUrl(projectId)}/assets/${asset}`, Date.now());
};

interface DraftUtils {
  getProjectDraftUrl: (projectId: number) => string;
  getProjectDraftFileUrl: (awsPath: (string, number) => string, projectId: number) => string;
  getProjectDraftAssetUrl: (
    awsPath: (string, number) => string,
    projectId: number,
    asset: string,
  ) => string;
}

const draft: DraftUtils = {
  getProjectDraftUrl,
  getProjectDraftFileUrl,
  getProjectDraftAssetUrl,
};

export default draft;
